const mediaQueries = {
  desktop: "@media only screen and (min-width: 1024px)",
  largeDesktop: "@media only screen and (min-width: 1200px)",
  tablet: "@media only screen and (min-width: 768px)"
}

export default mediaQueries
